import { PropBetsController } from "./prop-bets.controller";

const propBetsBlockComponent = {
	bindings: {},
	template: require("./external-prop-bets.html"),
	controller: PropBetsController,
	controllerAs: "vbc",
};

export default propBetsBlockComponent;